import { render, staticRenderFns } from "./modifyDefaultTemplateModel.vue?vue&type=template&id=6dbcc676&"
import script from "./modifyDefaultTemplateModel.vue?vue&type=script&lang=js&"
export * from "./modifyDefaultTemplateModel.vue?vue&type=script&lang=js&"
import style0 from "./modifyDefaultTemplateModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports